'use client';
import { useEffect, useState } from 'react';
import { getArticles, setContentDynamicSections } from '../../lib/ConnectApi';
import ArticlesSection from './ArticlesSection';
import AutoresSection from './AutoresSection';
import BookCovers from './BookCovers';

export default function DynamicSections() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchData = await getArticles();
        fetchData && setData(fetchData), setLoading(false);
      } catch (error) {
        console.error('Error fetching data: ', error);
      }
    };
    fetchData();
  }, []);
  const articles = setContentDynamicSections(data, 'article');
  const books = setContentDynamicSections(data, 'book');
  const authors = setContentDynamicSections(data, 'author');
  return (
    <div>
      <BookCovers books={books ? books : []} loading={loading} />
      <ArticlesSection articles={articles ? articles : []} loading={loading} />
      <AutoresSection
        authors={authors ? authors : []}
        books={books ? books : []}
        loading={loading}
      />
    </div>
  );
}
